
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ContentListAPI, roleDataGetAPI } from "../../Api/ContactApi";
import { getAllDefaultPackagesAPI } from "../../Api/Project/DefaultServices/DefaultServicesApi";
import { getAllProjectsAPI, getSharedFoldersByUserToken, ProjectContentListAPI } from "../../Api/ProjectApi";
import { fetchDefaultPackagesFailure, fetchDefaultPackagesStart, fetchDefaultPackagesSuccess } from "../Slices/projectDetailsSlice";
import { fetchContactFailure, fetchContactStart, fetchContactSuccess, fetchProjectFailure, fetchProjectStart, fetchProjectSuccess, fetchProjectSuccessAndSetSelectedProjectUpdate, fetchUserRoleFailure, fetchUserRoleStart, fetchUserRoleSuccess } from "../Slices/projectSlice";
import { AppDispatch } from "../Store";
import { mapSharedFolders } from "../Types/Project/SharedFolder";

export const fetchAllProjects = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchProjectStart())
        const data = await getAllProjectsAPI();
        if (data.status) {
            dispatch(fetchProjectSuccess(data.data || []))
        } else {
            dispatch(fetchProjectFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchProjectFailure(e!.toString()))
    }
}

export const fetchAllContact = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ProjectContentListAPI();
        if (data.status) {
            dispatch(fetchContactSuccess(data.data || []))
        } else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllUserRole = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchUserRoleStart())
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            dispatch(fetchUserRoleSuccess(data.data || []))
        } else {
            dispatch(fetchUserRoleFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchUserRoleFailure(e!.toString()))
    }
}

export const fetchAllProjectAfterEdit = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchProjectStart())
        const data = await getAllProjectsAPI();
        if (data.status) {
            dispatch(fetchProjectSuccessAndSetSelectedProjectUpdate(data.data || []))
        } else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const getAllDefaultPackages = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchDefaultPackagesStart())
        const data = await getAllDefaultPackagesAPI();
        if (data.status) {
            dispatch(fetchDefaultPackagesSuccess(data.data || []))
        } else {
            dispatch(fetchDefaultPackagesFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchDefaultPackagesFailure(e!.toString()))
    }
}


// get contact employee list
export const getSharedFoldersData = createAsyncThunk('getSharedFoldersData', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getSharedFoldersByUserToken();
        if (response.status) {
            return mapSharedFolders(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch all projet details');
    }
});
